import { IconButton } from '@hub/button';
import { HamburgerMediumIcon } from '@hub/icon';
import React from 'react';
import { useHeaderProps } from './header';
import { jsx as _jsx } from "react/jsx-runtime";
export const HeaderPrimaryMenuButton = () => {
  const {
    onClickPrimaryMenu
  } = useHeaderProps();
  return /*#__PURE__*/_jsx(IconButton, {
    variant: "transparent",
    colorScheme: "licorice",
    size: "icon-lg",
    icon: /*#__PURE__*/_jsx(HamburgerMediumIcon, {
      boxSize: "size-icon-md",
      "data-id": "header_header-primary-menu-button_HeaderPrimaryMenuButton_HamburgerMediumIcon"
    }),
    onClick: onClickPrimaryMenu !== null && onClickPrimaryMenu !== void 0 ? onClickPrimaryMenu : () => {},
    "aria-label": "navigation menu",
    "data-id": "header_header-primary-menu-button_HeaderPrimaryMenuButton_IconButton"
  });
};